import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { PhysicalAssetsReview } from "../components/PhysicalAssetsReview";
import { AddPhysicalAsset } from "../components/AddPhysicalAsset";

export function createValuablesScreens(firstName: string): FlowScreenConfig[] {
  return [
    {
      id: "add_personal_property_step",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: PhysicalAssetsReview,
      shouldDisplay: ({ answers }) => answers["physical_assets_review"] !== "none",
    },
    {
      id: "has_physical_assets",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: `Did ${firstName} own any valuable personal property?`,
      subtitle:
        "This includes high value assets like art, collections, memorabilia, jewelry and other items worth over $1,000.",
      question: {
        type: "multiple_choice",
        required: true,
        options: [
          { value: "yes", label: "Yes, they had valuables" },
          { value: "no", label: "No valuable items" },
          { value: "not_sure", label: "Not sure" },
        ],
      },
      shouldDisplay: ({ answers }) => answers["physical_assets_review"] === "none",
    },
    {
      id: "add_physical_asset",
      layout: "full",
      maxWidth: "4xl",
      hideButton: true,
      skipOnBack: true,
      customComponent: AddPhysicalAsset,
      shouldDisplay: ({ answers }) =>
        answers["has_physical_assets"] === "yes" && answers["add_physical_asset"] !== "done",
    },
  ];
}
